import React from 'react';
import Box, {BoxParams} from './Box';

export type RowParams = {
  maxLetters: number;
  letters: BoxParams[];
};

const Row = ({letters, maxLetters}:RowParams) => {
  const boxes = new Array(maxLetters)
    .fill(undefined)
    .map((_,col) =>
      <Box key={`Box-${col}`} {...letters[col]} index={col}/>
    )

  return (
    <div className="Row">
      {boxes}
    </div>
  )
}

export default Row;
